import { ReferenceGenerationError } from '../../domain/errors/ReferenceGenerationError';
import { unsetReferenceModalToDisplay } from '../../legacy/actions/modals';
import { createCommand } from '../../utils';
import { LoadReferenceGenerationsCommand } from './LoadReferenceGenerationsCommand';
import {
    generationRequestEnded,
    generationRequestFailed,
    generationRequestStarted,
    generationRequestSucceeded,
    moduleName,
} from '../state';

export const StartReferenceGenerationCommand = createCommand(
    `${moduleName}/START_REFERENCE_GENERATION`,
    async (_, { dispatch, extra }) => {
        dispatch(generationRequestStarted());
        dispatch(unsetReferenceModalToDisplay());
        try {
            const generation = await extra.externalReference.startReferenceGeneration();
            dispatch(generationRequestSucceeded(generation));
        } catch (err) {
            if (err instanceof ReferenceGenerationError && err.reason === 'already_running') {
                // Someone else started one: follow that one instead of showing an error.
                dispatch(generationRequestEnded());
                await dispatch(LoadReferenceGenerationsCommand());

                return;
            }
            dispatch(generationRequestFailed(err instanceof ReferenceGenerationError ? err.reason : 'unknown'));
        }
    },
);
